import { render } from "./MMMemberAssessmentResult.vue?vue&type=template&id=c6fc3902"
import script from "./MMMemberAssessmentResult.vue?vue&type=script&lang=js"
export * from "./MMMemberAssessmentResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__